import {toast} from 'react-toastify';

const INITIAL_STATE = {
  do_contrato: [],
  carregando: false,
  do_usuario:[],
  nVisualizadoGeral:[],
  nVisualizadoAtrazo:[],
  nVisualizadoFinalizados:[],
  nVisualizadoComissao:[],
  erro: null,
  ultimo: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case 'REQUISITAR_ACAO':
      return {...state, carregando: true};
    case 'ERRO_ACAO':
      toast.error(action.erro.message, 5000);
      return {...state, carregando: false, erro: action.erro};
    case 'OBTER_ACOES_CONTRATO':
      return {...state, carregando: false, do_contrato: action.acoes};
    case 'NOVA_ACAO':
    //toast.success("nova acaçao")
      return {...state, carregando: false};
    case 'OBTER_ACOES_ATOR':

      return {...state, carregando: false,
         do_usuario: action.acoes,
         nVisualizadoGeral: action.acoes.filter((acao) => {return acao.tipo==="notificacao"}),
         nVisualizadoAtrazo: action.acoes.filter((acao) => {return acao.tipo==="atrazado"}),
         nVisualizadoFinalizados: action.acoes.filter((acao) => {return acao.tipo==="finalizado"}),
         nVisualizadoComissao: action.acoes.filter((acao) => {return acao.tipo==="comissao"})
       };
    case 'VISUALIZAR_ACAO':
      //toast.success("Marcado como visto!", 5000);
      if(action.acao.tipo === "notificacao"){
        return {...state, carregando: false, nVisualizadoGeral: state.nVisualizadoGeral.filter((acao) => {return acao.id!==action.acao.id})};
      }else if(action.acao.tipo === "atrazado"){
        return {...state, carregando: false, nVisualizadoAtrazo: state.nVisualizadoAtrazo.filter((acao) => {return acao.id!==action.acao.id})};
      }else if(action.acao.tipo === "finalizado"){
        return {...state, carregando: false, nVisualizadoFinalizados: state.nVisualizadoFinalizados.filter((acao) => {return acao.id!==action.acao.id})};
      }else if(action.acao.tipo === "comissao"){
        return {...state, carregando: false, nVisualizadoComissao: state.nVisualizadoComissao.filter((acao) => {return acao.id!==action.acao.id})};
      }
      return {...state, carregando: false, nVisualizadoGeral: state.nVisualizadoGeral.filter((acao) => {return acao.id!==action.acao.id})};

    case 'OBTER_ACOES_ATOR_NV':
      //toast.success("obteve as notificacoes geral", 5000);
      return {...state, carregando: false, nVisualizadoGeral: action.acoes};
    case 'OBTER_ACOES_ATOR_NV_ATRAZO':
      //toast.success("obteve as notificacoes atrazado", 5000);
      return {...state, carregando: false, nVisualizadoAtrazo: action.acoes};
    case 'OBTER_ACOES_ATOR_NV_FINALIZADOS':
      //toast.success("obteve as notificacoes finalizado", 5000);
      return {...state, carregando: false, nVisualizadoFinalizados: action.acoes};
    case 'OBTER_ACOES_ATOR_NV_COMISSAO':
      //toast.success("obteve as notificacoes comissao", 5000);
      return {...state, carregando: false, nVisualizadoComissao: action.acoes};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/AcaoReducer.js